module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/pptx-70f77.png";